<template>
  <div class="forum">
    <div>
      <ForumCard :values="forum" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { getCommunity } from "@/service/forum";

import ForumCard from "@/components/ForumCard";

export default {
  name: "HomeView",
  data() {
    return {
      forum: null,
    };
  },
  components: {
    ForumCard,
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      const aliase = this.$route.params.aliase ? this.$route.params.aliase : -1;
      getCommunity(aliase)
        .then((response) => {
          this.forum = response.data;

          this.$store.dispatch("app/setBreadcrumb", [
            {
              key: 1,
              link: "/forums/" + this.forum.aliase + ".html",
              value: this.forum.name,
            },
          ]);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style lang="less"></style>
